import { TuiDayRange, TuiDay, TUI_FIRST_DAY, TUI_LAST_DAY, TuiMonth } from '@taiga-ui/cdk/date-time';
import { __decorate } from 'tslib';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, EventEmitter, Component, ChangeDetectionStrategy, Input, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TUI_FALSE_HANDLER } from '@taiga-ui/cdk/constants';
import { tuiWatch } from '@taiga-ui/cdk/observables';
import { TuiMapperPipe } from '@taiga-ui/cdk/pipes/mapper';
import { tuiIsString, tuiNullableSame, tuiPure } from '@taiga-ui/cdk/utils/miscellaneous';
import { tuiCalendarSheetOptionsProvider, TuiCalendar } from '@taiga-ui/core/components/calendar';
import * as i1 from '@taiga-ui/core/components/data-list';
import { TuiDataList } from '@taiga-ui/core/components/data-list';
import { TuiIcon } from '@taiga-ui/core/components/icon';
import { TUI_COMMON_ICONS } from '@taiga-ui/core/tokens';
import { TUI_OTHER_DATE_TEXT, TUI_CALENDAR_DATE_STREAM } from '@taiga-ui/kit/tokens';
const _c0 = (a0, a1, a2, a3) => [a0, a1, a2, a3, false];
const _c1 = (a0, a1, a2, a3) => [a0, a1, a2, a3, true];
const _c2 = (a0, a1, a2, a3, a4, a5) => [a0, a1, a2, a3, a4, a5];
function TuiCalendarRange_tui_calendar_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tui-calendar", 3);
    i0.ɵɵpipe(1, "tuiMapper");
    i0.ɵɵpipe(2, "tuiMapper");
    i0.ɵɵpipe(3, "tuiMapper");
    i0.ɵɵpipe(4, "tuiMapper");
    i0.ɵɵtwoWayListener("hoveredItemChange", function TuiCalendarRange_tui_calendar_4_Template_tui_calendar_hoveredItemChange_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.hoveredItem, $event) || (ctx_r2.hoveredItem = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("dayClick", function TuiCalendarRange_tui_calendar_4_Template_tui_calendar_dayClick_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onDayClick($event));
    })("monthChange", function TuiCalendarRange_tui_calendar_4_Template_tui_calendar_monthChange_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onMonthChange($event.append({
        month: -1
      })));
    })("mousedown.prevent.zoneless", function TuiCalendarRange_tui_calendar_4_Template_tui_calendar_mousedown_prevent_zoneless_0_listener() {
      i0.ɵɵrestoreView(_r2);
      return i0.ɵɵresetView(0);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabledItemHandler", ctx_r2.calculatedDisabledItemHandler)("markerHandler", ctx_r2.markerHandler)("max", i0.ɵɵpipeBindV(1, 9, i0.ɵɵpureFunction4(29, _c0, ctx_r2.max, ctx_r2.capsMapper, ctx_r2.value, ctx_r2.maxLength)))("min", i0.ɵɵpipeBindV(2, 15, i0.ɵɵpureFunction4(34, _c1, ctx_r2.min, ctx_r2.capsMapper, ctx_r2.value, ctx_r2.maxLength)))("minViewedMonth", i0.ɵɵpipeBind3(3, 21, ctx_r2.defaultViewedMonth, ctx_r2.monthOffset, 1))("month", i0.ɵɵpipeBind3(4, 25, ctx_r2.defaultViewedMonth, ctx_r2.monthOffset, 1))("showAdjacent", false)("value", ctx_r2.value);
    i0.ɵɵtwoWayProperty("hoveredItem", ctx_r2.hoveredItem);
  }
}
function TuiCalendarRange_ng_template_5_button_1_tui_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-icon", 8);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleProp("font-size", 1, "rem");
    i0.ɵɵproperty("icon", ctx_r2.icons.check);
  }
}
function TuiCalendarRange_ng_template_5_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function TuiCalendarRange_ng_template_5_button_1_Template_button_click_0_listener() {
      const item_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onItemSelect(item_r5));
    })("mousedown.prevent.zoneless", function TuiCalendarRange_ng_template_5_button_1_Template_button_mousedown_prevent_zoneless_0_listener() {
      i0.ɵɵrestoreView(_r4);
      return i0.ɵɵresetView(0);
    });
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, TuiCalendarRange_ng_template_5_button_1_tui_icon_2_Template, 1, 3, "tui-icon", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-checked", ctx_r2.isItemActive(item_r5));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r5, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isItemActive(item_r5));
  }
}
function TuiCalendarRange_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tui-data-list", 4);
    i0.ɵɵtemplate(1, TuiCalendarRange_ng_template_5_button_1_Template, 3, 3, "button", 5);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "tuiMapper");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("flex", 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBindV(3, 5, i0.ɵɵpureFunction6(12, _c2, ctx_r2.items, ctx_r2.mapper, ctx_r2.min, ctx_r2.max, ctx_r2.minLength, i0.ɵɵpipeBind1(2, 3, ctx_r2.otherDateText$))));
  }
}
const calculateDisabledItemHandler = (disabledItemHandler, value, minLength) => item => {
  if (!value || value instanceof TuiDayRange || !minLength) {
    return disabledItemHandler(item);
  }
  const negativeMinLength = Object.fromEntries(Object.entries(minLength).map(([key, value]) => [key, -value]));
  const disabledBefore = value.append(negativeMinLength).append({
    day: 1
  });
  const disabledAfter = value.append(minLength).append({
    day: -1
  });
  const inDisabledRange = disabledBefore.dayBefore(item) && disabledAfter.dayAfter(item);
  return inDisabledRange || disabledItemHandler(item);
};
const TUI_DAY_CAPS_MAPPER = (current, value, maxLength, backwards) => {
  if (value instanceof TuiDay || !value?.isSingleDay || !maxLength) {
    return backwards ? current || TUI_FIRST_DAY : current || TUI_LAST_DAY;
  }
  const negativeMaxLength = Object.fromEntries(Object.entries(maxLength).map(([key, value]) => [key, -value]));
  const dateShift = value.from.append(backwards ? negativeMaxLength : maxLength).append({
    day: !backwards ? -1 : 1
  });
  if (backwards) {
    return dateShift.dayBefore(current || TUI_FIRST_DAY) ? current || TUI_FIRST_DAY : dateShift;
  }
  if (!current) {
    return dateShift;
  }
  return dateShift.dayAfter(current) ? current : dateShift;
};
let TuiCalendarRange = /*#__PURE__*/(() => {
  class TuiCalendarRange {
    constructor() {
      /**
       * @deprecated use `item`
       */
      this.selectedPeriod = null;
      this.value = null;
      this.previousValue = null;
      this.hoveredItem = null;
      this.month = TuiMonth.currentLocal();
      this.otherDateText$ = inject(TUI_OTHER_DATE_TEXT);
      this.icons = inject(TUI_COMMON_ICONS);
      this.capsMapper = TUI_DAY_CAPS_MAPPER;
      this.disabledItemHandler = TUI_FALSE_HANDLER;
      this.markerHandler = null;
      this.items = [];
      this.min = TUI_FIRST_DAY;
      this.max = TUI_LAST_DAY;
      this.minLength = null;
      this.maxLength = null;
      this.item = null;
      this.valueChange = new EventEmitter();
      this.itemChange = new EventEmitter();
      this.monthOffset = (value, month) => value.append({
        month
      });
      this.mapper = (items, min, max, minLength, otherDateText) => [...items.filter(item => (minLength === null || item.range.from.append(minLength).append({
        day: -1
      }).daySameOrBefore(item.range.to)) && (min === null || item.range.to.daySameOrAfter(min)) && (max === null || item.range.from.daySameOrBefore(max))), otherDateText || ''];
      inject(TUI_CALENDAR_DATE_STREAM, {
        optional: true
      })?.pipe(tuiWatch(), takeUntilDestroyed()).subscribe(value => {
        this.value = value;
        this.initDefaultViewedMonth();
      });
    }
    set valueSetter(value) {
      this.value = value;
    }
    set defaultViewedMonth(month) {
      if (!this.value) {
        this.month = month;
      }
    }
    get defaultViewedMonth() {
      return this.month;
    }
    /**
     * @deprecated use `item`
     */
    get selectedActivePeriod() {
      return this.selectedPeriod;
    }
    /**
     * @deprecated use `item`
     */
    set selectedActivePeriod(period) {
      this.selectedPeriod = period;
    }
    ngOnChanges() {
      if (!this.value) {
        this.initDefaultViewedMonth();
      }
    }
    ngOnInit() {
      this.initDefaultViewedMonth();
    }
    get calculatedDisabledItemHandler() {
      return this.calculateDisabledItemHandler(this.disabledItemHandler, this.value, this.minLength);
    }
    onEsc(event) {
      if (event.key !== 'Escape' || !(this.value instanceof TuiDay)) {
        return;
      }
      event.stopPropagation();
      this.value = this.previousValue;
    }
    isItemActive(item) {
      const {
        activePeriod
      } = this;
      return tuiIsString(item) && activePeriod === null || activePeriod === item || activePeriod?.toString() === item.toString();
    }
    onItemSelect(item) {
      if (!tuiIsString(item)) {
        this.selectedActivePeriod = item;
        this.updateValue(item.range.dayLimit(this.min, this.max));
        this.itemChange.emit(item);
      } else if (this.activePeriod !== null) {
        this.selectedActivePeriod = null;
        this.updateValue(null);
        this.itemChange.emit(null);
      }
      this.initDefaultViewedMonth();
    }
    onMonthChange(month) {
      this.month = month;
    }
    onDayClick(day) {
      this.previousValue = this.value;
      this.selectedActivePeriod = null;
      if (this.value instanceof TuiDay) {
        const range = TuiDayRange.sort(this.value, day);
        this.value = range;
        this.updateValue(range);
        this.itemChange.emit(this.findItemByDayRange(range));
      } else {
        this.value = day;
      }
    }
    updateValue(value) {
      this.value = value;
      this.valueChange.emit(value);
    }
    get activePeriod() {
      return this.item ?? this.selectedActivePeriod ?? (this.items.find(item => tuiNullableSame(this.value instanceof TuiDay ? new TuiDayRange(this.value, this.value) : this.value, item.range, (a, b) => a.from.daySame(b.from.dayLimit(this.min, this.max)) && a.to.daySame(b.to.dayLimit(this.min, this.max)))) || null);
    }
    calculateDisabledItemHandler(disabledItemHandler, value, minLength) {
      return calculateDisabledItemHandler(disabledItemHandler, value, minLength);
    }
    initDefaultViewedMonth() {
      if (this.value instanceof TuiDay) {
        this.month = this.value;
      } else if (this.value) {
        this.month = this.items.length ? this.value.to : this.value.from;
      } else if (this.max && this.month.monthSameOrAfter(this.max)) {
        this.month = this.items.length ? this.max : this.max.append({
          month: -1
        });
      } else if (this.min && this.month.monthSameOrBefore(this.min)) {
        this.month = this.min;
      }
    }
    findItemByDayRange(dayRange) {
      return this.items.find(item => dayRange.daySame(item.range)) ?? null;
    }
    static {
      this.ɵfac = function TuiCalendarRange_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiCalendarRange)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiCalendarRange,
        selectors: [["tui-calendar-range"]],
        hostBindings: function TuiCalendarRange_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown.capture", function TuiCalendarRange_keydown_capture_HostBindingHandler($event) {
              return ctx.onEsc($event);
            }, false, i0.ɵɵresolveDocument);
          }
        },
        inputs: {
          disabledItemHandler: "disabledItemHandler",
          markerHandler: "markerHandler",
          items: "items",
          min: "min",
          max: "max",
          minLength: "minLength",
          maxLength: "maxLength",
          item: "item",
          valueSetter: [0, "value", "valueSetter"],
          defaultViewedMonth: "defaultViewedMonth"
        },
        outputs: {
          valueChange: "valueChange",
          itemChange: "itemChange"
        },
        features: [i0.ɵɵProvidersFeature([tuiCalendarSheetOptionsProvider({
          rangeMode: true
        })]), i0.ɵɵNgOnChangesFeature],
        decls: 7,
        vars: 37,
        consts: [["presets", ""], ["automation-id", "tui-calendar-range__calendar", 1, "t-calendar", 3, "hoveredItemChange", "dayClick", "monthChange", "mousedown.prevent.zoneless", "disabledItemHandler", "markerHandler", "max", "maxViewedMonth", "min", "month", "showAdjacent", "value", "hoveredItem"], [3, "disabledItemHandler", "markerHandler", "max", "min", "minViewedMonth", "month", "showAdjacent", "value", "hoveredItem", "hoveredItemChange", "dayClick", "monthChange", "mousedown.prevent.zoneless", 4, "ngIf", "ngIfElse"], [3, "hoveredItemChange", "dayClick", "monthChange", "mousedown.prevent.zoneless", "disabledItemHandler", "markerHandler", "max", "min", "minViewedMonth", "month", "showAdjacent", "value", "hoveredItem"], ["automation-id", "tui-calendar-range__menu", "role", "menu"], ["automation-id", "tui-calendar-range__menu__item", "role", "menuitemradio", "tuiOption", "", "type", "button", 3, "click", "mousedown.prevent.zoneless", 4, "ngFor", "ngForOf"], ["automation-id", "tui-calendar-range__menu__item", "role", "menuitemradio", "tuiOption", "", "type", "button", 3, "click", "mousedown.prevent.zoneless"], ["automation-id", "tui-calendar-range__checkmark", 3, "icon", "font-size", 4, "ngIf"], ["automation-id", "tui-calendar-range__checkmark", 3, "icon"]],
        template: function TuiCalendarRange_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "tui-calendar", 1);
            i0.ɵɵpipe(1, "tuiMapper");
            i0.ɵɵpipe(2, "tuiMapper");
            i0.ɵɵpipe(3, "tuiMapper");
            i0.ɵɵtwoWayListener("hoveredItemChange", function TuiCalendarRange_Template_tui_calendar_hoveredItemChange_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.hoveredItem, $event) || (ctx.hoveredItem = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("dayClick", function TuiCalendarRange_Template_tui_calendar_dayClick_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onDayClick($event));
            })("monthChange", function TuiCalendarRange_Template_tui_calendar_monthChange_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onMonthChange($event));
            })("mousedown.prevent.zoneless", function TuiCalendarRange_Template_tui_calendar_mousedown_prevent_zoneless_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(0);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, TuiCalendarRange_tui_calendar_4_Template, 5, 39, "tui-calendar", 2)(5, TuiCalendarRange_ng_template_5_Template, 4, 19, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const presets_r6 = i0.ɵɵreference(6);
            i0.ɵɵproperty("disabledItemHandler", ctx.calculatedDisabledItemHandler)("markerHandler", ctx.markerHandler)("max", i0.ɵɵpipeBindV(1, 11, i0.ɵɵpureFunction4(27, _c0, ctx.max, ctx.capsMapper, ctx.value, ctx.maxLength)))("maxViewedMonth", ctx.items.length ? null : i0.ɵɵpipeBind3(2, 17, ctx.defaultViewedMonth, ctx.monthOffset, -1))("min", i0.ɵɵpipeBindV(3, 21, i0.ɵɵpureFunction4(32, _c1, ctx.min, ctx.capsMapper, ctx.value, ctx.maxLength)))("month", ctx.defaultViewedMonth)("showAdjacent", !!ctx.items.length)("value", ctx.value);
            i0.ɵɵtwoWayProperty("hoveredItem", ctx.hoveredItem);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", !ctx.items.length)("ngIfElse", presets_r6);
          }
        },
        dependencies: [AsyncPipe, NgForOf, NgIf, TuiCalendar, i1.TuiDataListComponent, i1.TuiOption, TuiIcon, TuiMapperPipe],
        styles: ["[_nghost-%COMP%]{display:flex;min-inline-size:30rem}.t-calendar[_ngcontent-%COMP%]{border-inline-end:1px solid var(--tui-border-normal)}"],
        changeDetection: 0
      });
    }
  }
  __decorate([tuiPure], TuiCalendarRange.prototype, "calculateDisabledItemHandler", null);
  return TuiCalendarRange;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class TuiDayRangePeriod {
  constructor(range, name, content) {
    this.range = range;
    this.name = name;
    this.content = content;
  }
  toString() {
    return this.name;
  }
}
function tuiCreateDefaultDayRangePeriods(periodTitles = ['For all the time', 'Today', 'Yesterday', 'Current week', 'Current month', 'Previous month']) {
  const today = TuiDay.currentLocal();
  const yesterday = today.append({
    day: -1
  });
  const startOfWeek = today.append({
    day: -today.dayOfWeek()
  });
  const endOfWeek = startOfWeek.append({
    day: 6
  });
  const startOfMonth = today.append({
    day: 1 - today.day
  });
  const endOfMonth = startOfMonth.append({
    month: 1,
    day: -1
  });
  const startOfLastMonth = startOfMonth.append({
    month: -1
  });
  return [new TuiDayRangePeriod(new TuiDayRange(TUI_FIRST_DAY, today), periodTitles[0]), new TuiDayRangePeriod(new TuiDayRange(today, today), periodTitles[1]), new TuiDayRangePeriod(new TuiDayRange(yesterday, yesterday), periodTitles[2]), new TuiDayRangePeriod(new TuiDayRange(startOfWeek, endOfWeek), periodTitles[3]), new TuiDayRangePeriod(new TuiDayRange(startOfMonth, endOfMonth), periodTitles[4]), new TuiDayRangePeriod(new TuiDayRange(startOfLastMonth, startOfMonth.append({
    day: -1
  })), periodTitles[5])];
}

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_DAY_CAPS_MAPPER, TuiCalendarRange, TuiDayRangePeriod, calculateDisabledItemHandler, tuiCreateDefaultDayRangePeriods };
